import React from 'react'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'

import { TtAvatar } from '@23/react'

import { AttendeeDemoter } from '../../features/SpeakersFeature/components/SpeakerBaseDetailsComponent/attendee-demoter'
import { useWebinarColors } from '../../hooks/useWebinarColors'

import GenericSpeakerList, {
  type GenericSpeakerListItemProps,
} from './GenericSpeakerList'

import './WebinarInfoSidebarGuestSpeakerList.scss'

const SpeakerEntry = ({ speaker }: GenericSpeakerListItemProps) => {
  const { id, name, fullName, question, guestSpeakerPreviewLink } = speaker
  const { tabs } = useWebinarColors()

  return (
    <div
      key={id}
      className="webinar-info-sidebar-guest-speaker-list-item"
      style={{ borderBottomColor: tabs.contrast.transparent('5%') }}
    >
      <TtAvatar label={name} image={guestSpeakerPreviewLink} />
      <div className="speaker-info">
        <div className="speaker-info-name">
          <span className="speaker-info-short-name">
            <FormattedMessage
              defaultMessage="{fullName}<conditional>(shown as {name})</conditional>"
              values={{
                fullName,
                name,
                // eslint-disable-next-line react/no-unstable-nested-components
                conditional: (...chunks) => (
                  <>{fullName !== name ? chunks : ''}</>
                ),
              }}
            />
          </span>
        </div>
        <div className="speaker-info-subline">
          {question && (
            <FormattedMessage
              defaultMessage="Question: {question}"
              values={{ question }}
            />
          )}
        </div>
      </div>
      <AttendeeDemoter attendeeId={id} attendeeName={name} />
    </div>
  )
}

const WebinarInfoSidebarGuestSpeakerList = () => {
  return (
    <div className="webinar-info-sidebar-guest-speaker-list">
      <GenericSpeakerList
        filter={(speaker) => speaker.creationSource === 'guest'}
        renderItem={({ speaker }) => (
          <SpeakerEntry key={speaker.id} speaker={speaker} />
        )}
        placeholder={intl.formatMessage({
          defaultMessage: 'No one is on camera right now',
        })}
      />
    </div>
  )
}

export default WebinarInfoSidebarGuestSpeakerList
